import FormDialog from "../../../components/common/FormDialog";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import { useEffect, useState } from "react";
import { asyncRequest } from "src/services/network";
import MyPagination from "src/components/common/MyPagination";
import MerchantInfo from "src/components/common/MerchantInfo";

const AreaMersStatDialog = ({ districtId, districtName, open, onClose}) => {

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    // provinceId: null,
    // cityId: null,
    districtId,
    // createdAt: null,
    // sort: "today",
    // order: "DESC",
  });

  useEffect(() => {
    getItems();
  }, [filter])

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/stats/merchant/rank",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  return (
    <FormDialog title={`${districtName}区业绩`} open={open} onClose={onClose} onConfirm={onClose}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">商户</TableCell>
              <TableCell align="left">业绩</TableCell>
              <TableCell align="left">消费笔数</TableCell>
              <TableCell align="left">入驻时间</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((row) => (
              <TableRow key={row.name} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell align="left">
                  <MerchantInfo {...row} />  
                </TableCell>
                <TableCell align="left">{row.rangli || 0}</TableCell>
                <TableCell align="left">{row.count || 0}</TableCell>
                {/* <TableCell align="left">{row.daily ? row.daily[0].rangli : 0}</TableCell> */}
                <TableCell align="left">{moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
    </FormDialog>
  );
};

export default AreaMersStatDialog;
